import useNavStore from "zustandStores/useNavStore";
import useHeaderStore from "zustandStores/useHeaderStore";
import { useRouter } from "next/router";
import { getHeaderConfig } from "utils/layoutConfig";
import { Menu, ArrowLeft } from "lucide-react";
import dynamic from "next/dynamic";
import CustomerSupport from "components/CustomerSupport/CustomerSupport";
import { JhText } from "designPackages/textPackage";
import HeaderActions from "components/ResponseManagerV3/HeaderActions";
import PremiumJobIcon from "components/ResponseManagerV3/HeaderActions/PremiumJobIcon";
import BulkWhatsAppCTA from "components/BulkWhatsAppCTA";
import ViewAllBroadcastsButton from "components/ViewAllBroadcastsButton";
import LogService from "services/LogService";
import NavEvents from "utils/Events/navEvents";

const CreditBalance = dynamic(() => import("components/CreditBalance"), {
  ssr: false
});

const HeaderV2 = () => {
  const { navState, setNavState } = useNavStore(state => ({
    navState: state.navState,
    setNavState: state.setNavState
  }));

  const {
    title,
    subtitle,
    onBack,
    isHeaderAction,
    jobPlan,
    onJobBoost,
    onJobUpgrade,
    isJobClosed
  } = useHeaderStore(state => ({
    title: state.title,
    subtitle: state.subtitle,
    onBack: state.onBack,
    isHeaderAction: state.isHeaderAction,
    jobPlan: state.jobPlan,
    onJobBoost: state.onJobBoost,
    onJobUpgrade: state.onJobUpgrade,
    isJobClosed: state.isJobClosed
  }));

  const router = useRouter();
  const config = getHeaderConfig(router.pathname);
  if (!config.showHeader) {
    return null;
  }

  const handleBackClick = () => {
    if (onBack) {
      onBack();
    } else {
      LogService.log(NavEvents.BACK_BUTTON_CLICKED);
      router.back();
    }
  };

  return (
    <header
      id="header-root"
      className="sticky top-0 z-40 flex py-3 px-6 h-16 items-center gap-4 border-b tw-root
        bg-white/75 backdrop-blur supports-[backdrop-filter]:bg-white/75"
    >
      {config.sidebar?.visible ? (
        <button
          className="visible lg:hidden"
          onClick={() => setNavState(!navState)}
        >
          <Menu className="h-6 w-6" />
        </button>
      ) : config.showBack ? (
        <button className="visible" id="header-back" onClick={handleBackClick}>
          <div className="flex items-center justify-center h-8 w-8 border border-border rounded-md">
            <ArrowLeft className="h-4 w-4" />
          </div>
        </button>
      ) : null}
      <div className="flex-1">
        <div className="flex items-center gap-2  max-w-28 sm:max-w-lg">
          <h1 className={`text-sm font-semibold truncate`}>
            {title || config.title}
          </h1>
          <PremiumJobIcon jobPlan={jobPlan} />
        </div>
        {subtitle && (
          <JhText
            variant="caption2"
            color="muted-foreground"
            className="text-sm"
          >
            {subtitle}
          </JhText>
        )}
      </div>

      {/* Right side components */}
      <div className="flex items-center gap-2.5">
        {config.showViewAllBroadcastsButton ? (
          <ViewAllBroadcastsButton />
        ) : null}
        {config.showBulkWhatsAppCTA ? <BulkWhatsAppCTA /> : null}
        {isHeaderAction ? (
          <HeaderActions
            onJobBoostCallback={onJobBoost}
            onJobUpgradeCallback={onJobUpgrade}
            isJobClosed={isJobClosed}
          />
        ) : null}
        {config.showCredits ? <CreditBalance view="view5" /> : null}
        {config.hideCustomerSupport ? null : <CustomerSupport />}
      </div>
    </header>
  );
};
export default HeaderV2;
